class Booking_panel {
    constructor() {
        this.elements = document.querySelectorAll('[data-type="quick-book"]');
        this.panel = document.querySelector('.js-main-panel');
        this.close_panel = document.querySelector('.js-close-panel');
        this.tab_group = document.querySelector('.js-tab-group');
        this.tab_content_group = document.querySelector('.js-tab-content-group');
        this.tabs = this.tab_group && Array.from(this.tab_group.getElementsByTagName('a'));
        this.tabs_content = this.tab_content_group && Array.from(this.tab_content_group.getElementsByClassName('js-tab-content'));
        this.booking_btn = document.querySelector('.js-booking-btn');
        this.default_booking_link = document.getElementsByName('booking_engine_link');
    }

    get_booking_element() {
        var _self = this;
        _self.elements.forEach(function (element) {
            _self.open_booking_panel(element);
        })
    }

    toggle_panel_class() {
        var _self = this;
        _self.panel.removeAttribute('style');
        _self.panel.classList.toggle('js-hidden');
        _self.panel.classList.toggle('js-visible');
    }

    open_booking_panel(element) {
        var _self = this;
        element.addEventListener('click', function (e) {
            _self.toggle_panel_class()
        })
    }

    close_booking_panel() {
        var _self = this;
        _self.close_panel.addEventListener('click', function () {
            _self.toggle_panel_class();
        })
    }

    get_tab_index() {
        var _self = this;
        _self.tabs.forEach(function (el, index) {
            el.addEventListener('click', function () {
                _self.remove_child_class(_self.tabs, 'is_active');
                _self.remove_child_class(_self.tabs_content, 'is_active');
                _self.add_class_on_tab_content(index);
                el.classList.add('is_active');
            });
        });
    }

    remove_child_class(parent_el, active_class) {
        parent_el.forEach(function (e, i) {
            if (e.classList.contains(active_class)) {
                e.classList.remove(active_class)
            }
        })
    };

    add_class_on_tab_content(i) {
        var _self = this;
        _self.tabs_content[i].classList.add('is_active');
    }

    get_booking_url() {
        var _self = this;
        var booking_value = _self.default_booking_link[0].value;

        if (booking_value && typeof _self.booking_btn != 'undefined' && _self.booking_btn != null) {
            _self.booking_btn.addEventListener('click', function () {
                var booking_checkIN = document.getElementsByName('booking_checkIN')[0].value,
                    booking_checkOut = document.getElementsByName('booking_checkOut')[0].value,
                    modifyCheckIN = document.getElementsByName('checkin')[0].value,
                    modifyCheckOut = document.getElementsByName('ckeckout')[0].value,
                    promoCode = document.getElementsByName('promo')[0].value;

                if (modifyCheckIN) {
                    booking_checkIN = modifyCheckIN;
                }

                if (modifyCheckOut) {
                    booking_checkOut = modifyCheckOut;
                }

                var date1 = new Date(booking_checkIN);
                var date2 = new Date(booking_checkOut);
                var Difference_In_Time = date2.getTime() - date1.getTime();
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                if (promoCode.length) {
                    booking_value += 'index.php?av=promo&fw_submitted=1';
                    booking_value += '&promotionCode=' + promoCode;
                } else {
                    booking_value += 'index.php?av=search&fw_submitted=1';
                }

                var redirectURL = booking_value + '&checkin=' + booking_checkIN + '&nights=' + Difference_In_Days;
                window.location = redirectURL;
            })

        }

    }

    variation_1_init() {
        this.get_booking_url();
    }

    variation_2_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_booking_url();
    }

    variation_3_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_tab_index();
        this.get_booking_url();
    }
}

const panel = document.querySelector('.js-main-panel');
const variation = panel.dataset.variation;

if (typeof (panel) != 'undefined' && panel != null) {
    const booking_panel = new Booking_panel();
    if (variation == 'option_1') {
        booking_panel.variation_1_init();
    }

    if (variation == 'option_2') {
        booking_panel.variation_2_init();
    }

    if (variation == 'option_3') {
        booking_panel.variation_3_init();
    }
}